import { apiCall } from './api';

export interface UploadInput {
  historyId: number;
  blob: Blob;
  extension: 'mp4' | 'webm';
  contentType: string;
}

// Calls init -> PUTs blob directly to Spaces -> calls complete.
// Throws on any failure so the caller can decide whether to retry / persist.
export async function uploadPerformanceVideo(input: UploadInput): Promise<void> {
  const initRes = await apiCall(`/api/songs/history/${input.historyId}/video/init`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ extension: input.extension, content_type: input.contentType }),
  });
  if (!initRes.ok) {
    const body = await initRes.json().catch(() => ({}));
    throw new Error(body.error || `init failed: HTTP ${initRes.status}`);
  }
  const init = await initRes.json() as { upload_url: string; object_key: string; content_type: string };

  const putRes = await fetch(init.upload_url, {
    method: 'PUT',
    headers: { 'Content-Type': init.content_type },
    body: input.blob,
  });
  if (!putRes.ok) {
    throw new Error(`Spaces PUT failed: HTTP ${putRes.status}`);
  }

  const completeRes = await apiCall(`/api/songs/history/${input.historyId}/video/complete`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ object_key: init.object_key, size_bytes: input.blob.size }),
  });
  if (!completeRes.ok) {
    const body = await completeRes.json().catch(() => ({}));
    throw new Error(body.error || `complete failed: HTTP ${completeRes.status}`);
  }
}
